"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
class PartnerType {
    constructor(type, subType) {
        const typeData = PartnerType.allTypes[type];
        if (typeData) {
            this.type = type;
            if (subType && typeData.subTypes.includes(subType)) {
                this.subType = subType;
            }
        }
        else {
            this.type = __1.ePartnerType.ASSURED;
        }
    }
    static isAssured(partnerType) {
        return partnerType === __1.ePartnerType.ASSURED;
    }
    static isRetailer(partnerType) {
        return partnerType === __1.ePartnerType.RETAILER;
    }
    static isAnyRetailer(partnerType) {
        return partnerType === null || partnerType === void 0 ? void 0 : partnerType.includes(__1.ePartnerType.RETAILER);
    }
    static isWholesaler(partnerType) {
        return partnerType === __1.ePartnerType.WHOLESALER;
    }
    static isAnyWholesaler(partnerType) {
        return partnerType === null || partnerType === void 0 ? void 0 : partnerType.includes(__1.ePartnerType.WHOLESALER);
    }
    static fromPartnerTypeKey(partnerType) {
        var _a;
        const [type, subType] = (_a = partnerType === null || partnerType === void 0 ? void 0 : partnerType.split(":")) !== null && _a !== void 0 ? _a : [];
        return new PartnerType(type, subType);
    }
    static fromName(partnerTypeName) {
        var _a;
        const [type, subType] = (_a = partnerTypeName === null || partnerTypeName === void 0 ? void 0 : partnerTypeName.toUpperCase().split(" ")) !== null && _a !== void 0 ? _a : [];
        const typeData = type ? PartnerType.allTypes[type] : undefined;
        if (!typeData || (subType && !typeData.subTypes.includes(subType))) {
            return undefined;
        }
        return new PartnerType(type, subType);
    }
    get subTypes() {
        var _a;
        return (_a = PartnerType.allTypes[this.type]) === null || _a === void 0 ? void 0 : _a.subTypes;
    }
    static getAllPartnerTypes() {
        const partnerTypes = Object.entries(this.allTypes).reduce((list, [key, { subTypes }]) => {
            list.push(new PartnerType(key));
            subTypes.forEach((subTypeKey) => {
                list.push(new PartnerType(key, subTypeKey));
            });
            return list;
        }, []);
        return partnerTypes;
    }
    get id() {
        var _a, _b, _c, _d;
        const typeValue = (_b = (_a = PartnerType.allTypes[this.type]) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : 0;
        const subTypeValue = this.subType
            ? (_d = (_c = PartnerType.allSubTypes[this.subType]) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : 0
            : 0;
        return typeValue + subTypeValue;
    }
    get label() {
        var _a;
        return (_a = PartnerType.allTypes[this.type]) === null || _a === void 0 ? void 0 : _a.name;
    }
    get subLabel() {
        var _a;
        return this.subType
            ? (_a = PartnerType.allSubTypes[this.subType]) === null || _a === void 0 ? void 0 : _a.name
            : undefined;
    }
    get key() {
        if (this.subType) {
            return `${this.type}:${this.subType}`;
        }
        return this.type;
    }
    get name() {
        if (this.subType) {
            return `${this.label} ${this.subLabel}`;
        }
        return this.label;
    }
    isValidParentType(parentTypeVal) {
        const parentType = parentTypeVal instanceof PartnerType
            ? parentTypeVal
            : PartnerType.fromPartnerTypeKey(parentTypeVal);
        let valid = false;
        if (Math.floor(parentType.id) === Math.ceil(this.id) - 1) {
            valid = true;
        }
        else if (this.key === __1.ePartnerType.RETAILER &&
            parentType.key === __1.ePartnerType.PORTAL) {
            valid = true;
        }
        return valid;
    }
    static getSupportedPartnerTypes(parentPartnerTypeId, minChildPartnerTypeId) {
        return PartnerType.allPartnerTypes.filter(({ id }) => id > parentPartnerTypeId &&
            (!minChildPartnerTypeId || id < minChildPartnerTypeId));
    }
}
exports.default = PartnerType;
PartnerType.allSubTypes = {
    REGIONAL: { name: "Regional", id: 0.1 },
    OFFICE: { name: "Office", id: 0.2 },
    TEAM: { name: "Team", id: 0.3 }
};
PartnerType.subTypeKeys = Object.keys(PartnerType.allSubTypes);
PartnerType.allTypes = {
    PORTAL: {
        name: "Portal",
        id: 0,
        subTypes: []
    },
    WHOLESALER: {
        name: "Wholesaler",
        id: 1,
        subTypes: PartnerType.subTypeKeys
    },
    RETAILER: { name: "Retailer", id: 2, subTypes: PartnerType.subTypeKeys },
    ASSURED: { name: "Assured", id: 3, subTypes: [] }
};
PartnerType.allPartnerTypes = PartnerType.getAllPartnerTypes();
//# sourceMappingURL=partnerType.class.js.map